module.exports = __webpack_public_path__ + "media/images/award-badges-mobile-th-33f57f55815f346164e25b2d86b323b1.svg";